import smartSolveApi, { syncAPICall } from './instances/smartsolve';
import { waitForCachedData } from '../utils/cacheUtils';

export const supportDataCache = {};
export const onGoingCalls = {};

export const getSupportData = async (params, disableCache) => {
  try {
    // always cache for LISTDATA type
    if (params.dataSourceTypeStr === 'LISTDATA') {
      params.cacheData = true;
    }

    const strigifiedParams = JSON.stringify(params);
    const cacheKey = strigifiedParams;

    if (onGoingCalls[strigifiedParams]) {
      // wait for data
      const cachedData = await waitForCachedData(supportDataCache, cacheKey, 50);
      return cachedData;
    } else {
      onGoingCalls[strigifiedParams] = true;
    }

    if (cacheKey in supportDataCache && !disableCache) {
      return supportDataCache[cacheKey];
    }
    params.dataKeyField = '';
    //we're using sortExpression instead of orderBy parameter
    params.orderBy = null;

    const response = await smartSolveApi.post('/getSupportData', params);
    const { data } = response;

    supportDataCache[cacheKey] = data;

    delete onGoingCalls[strigifiedParams];

    return data;
  } catch (e) {
    throw new Error(`getSupportData() failed: ${e}`);
  }
};

const getDataSync = (params) => {
  // always cache for LISTDATA type
  if (params.dataSourceTypeStr === 'LISTDATA') {
    params.cacheData = true;
  }

  const strigifiedParams = JSON.stringify(params);
  const cacheKey = strigifiedParams;

  if (cacheKey in supportDataCache) {
    return supportDataCache[cacheKey];
  }
  params.dataKeyField = '';

  const response = syncAPICall('getSupportData', params);

  supportDataCache[cacheKey] = response;

  return response;
};

/**
 * Does SYNC request to 'getSupportData'
 * Dont use until you really need sync request
 *
 * @param params
 */
export const getSupportDataSync = (params) => {
  return getDataSync(params);
};
